import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  IReligion,
  IOccupation,
  IMeansOfIdentification,
  IEmploymentInfo,
  ISocialMediaPlatform,
  ICountry,
} from "../../../models/IEnums.model";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../../utils/localStorage";
import Icon_L from "../../../assets/images/Icon_L.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { formatBVNDate } from "../../../utils/formatDate";
import axios from "axios";
import { baseUrl } from "../../../utils/baseUrl";
import { setAccountOpeningStep } from "../../../redux/accountOpening";
import * as toast from "../../../utils/makeToast";
import { accountTypes } from "../../../utils/constants";
import CoperateAccountPopUp from "../../coperateAccountPopUp";

import OtpDialogModal from "../../OtpDialogModal";
import Loader from "../../Loader";
import { encryptRequest } from "../../../utils/encryption";
import { statesInNigeria } from "../../../utils/constants";
import Modal from "../../Modal";

function ExUpdateDetailsSavingsDialog(props: any) {
  const [intialPopup, setInitialPopup] = useState(true);
  const dispatch = useDispatch();

  const [updating, setUpdating] = useState(false);
  const [countries, setCountries] = useState<ICountry[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [showNinModal, setShowNinModal] = useState(false);
  const [showBvnMiddleEmptyModal, setShowBvnMiddleEmptyModal] = useState(false);
  const [showNinMiddleEmptyModal, setShowNinMiddleEmptyModal] = useState(false);
  const [showfirstNameModal, setShowfirstNameModal] = useState(false);
  const [showmiddleNameModal, setShowmiddleNameModal] = useState(false);
  const [showlastNameModal, setShowlastNameModal] = useState(false);
  const [showGenderNameModal, setShowGenderNameModal] = useState(false);
  const [showDobNameModal, setShowDoBNameModal] = useState(false);

  const [religions, setReligions] = useState<IReligion[]>([]);

  const [userDetails, setUserDetails] = useState(
    getLocalStorageItem("userDetails")
  );
  const [userNinPayload, setuserNinPayload] = useState(
    getLocalStorageItem("userNinPayload")
  );
  const [userNin, setUserNin] = useState(getLocalStorageItem("userNinPayload"));

  
  const [accountType, setAccountType] = useState(
    localStorage.getItem("altFinanceAccountType")
  );

  const [userExistingDetails, setUserExistingDetails] = useState<any>();

  const [todaysDate, setTodaysDate] = useState<any>(
    new Date().toISOString().split("T")[0]
  );
  const [socialMediaPlatforms, setSocialMediaPlatforms] = useState<
    ISocialMediaPlatform[]
  >([]);

  const [ninModalOpen, setNinModalOpen] = useState(false);

  const [otpLoader, setOtpLoader] = useState(false);

  const [idCardNumber, setIdCardNumber] = useState("");
  const [idCardIssueDate, setIdCardissueDate] = useState("");

  const [genders, SetGenders] = useState<any[]>([
    { name: "Male", value: "M" },
    { name: "Female", value: "F" },
  ]);

  const getCountries = () => {
    axios
      .get(`${baseUrl}Enum/Country`)
      .then((response) => {
        let nigeria = response?.data.find(
          (x) => x.lonG_DESC_ENG.toLowerCase() === "nigeria"
        );
        let otherCountries = response?.data.filter(
          (x) => x.lonG_DESC_ENG.toLowerCase() !== "nigeria"
        );
        let countries = [nigeria, ...otherCountries];
        setCountries(countries);
      })
      .catch((err) => {
        
      });
  };

  const goToStep = (step: any) => {
    dispatch(setAccountOpeningStep(step));
  };

  const validationSchemawithminorDob = {
    areaState: Yup.string().required("State is required"),
    nationality: Yup.string().required("Nationality is required"),
    streetName: Yup.string().required("Street name is required"),
    houseNumber: Yup.string().required("House number is required"),
    address: Yup.string().required("Address is required"),
    minorDob: Yup.string().required("Minor Date of Birth is required"),
    gender: Yup.string().required("Please Select a gender"),
    localGovernment: Yup.string().required("Local Government Area is required"),
    town: Yup.string().required("Town is required"),
  };
  const validationSchemawithoutminorDob = {
    areaState: Yup.string().required("State is required"),
    streetName: Yup.string().required("Street name is required"),
    houseNumber: Yup.string().required("House number is required"),
    address: Yup.string().required("Address is required"),
    nationality: Yup.string().required("Nationality is required"),
    gender: Yup.string().required("Please Select a gender"),
    localGovernment: Yup.string().required("Local Government Area is required"),
    town: Yup.string().required("Town is required"),
  };

  

  const formik = useFormik({
    initialValues: {
      firstName: userDetails.firstName,
      middleName: userDetails.middleName,
      lastName: userDetails.lastName,
      dob: formatBVNDate(
        userDetails.dateOfBirth ||
          userDetails?.dob ||
          userNinPayload?.dateOfBirth ||
          userNinPayload?.dob
      ),
      phoneNumber: userDetails.phoneNumber,
      emailAddress: "",
      houseNumber: "",
      streetName: "",
      areaState: "",
      nearestBustopLandmark: "",
      address: "",
      religion: "",
      nationality: "",
      selfEmploymentInformation: "",
      occupation: "",
      referralCode: "",

      minorDob: "",
      socialMediaId: "",
      socialMediaHandle: "",
      localGovernment: "",
      town: "",
      minorFirstName: "",
      minorMiddleName: "",
      minorLastName: "",
      gender: "",
    },
    validationSchema: Yup.object(
      accountType?.toLowerCase() === accountTypes.minorSavings.toLowerCase()
        ? validationSchemawithminorDob
        : validationSchemawithoutminorDob
      // if ( accountType?.toLowerCase() === accountTypes.minorSavings.toLowerCase()) {

      // }
    ),
    onSubmit: (values) => {
      updateDetails(values);
    },
  });

  const handleBlurAddressChild = () => {
    formik.setValues({
      ...formik.values,
      address: `${formik.values?.houseNumber || ""} ${
        formik.values?.streetName || ""
      } ${formik.values?.nearestBustopLandmark || ""} ${
        formik.values?.areaState || ""
      }`,
    });
  };

  const sendOtp = () => {
    setOtpLoader(true);
    let resendOtpPayload = {
      phoneNumber: userDetails.phoneNumber,
      customerName: `${userDetails.firstName} ${userDetails.lastName}`,
      bvn: userDetails.bvn,
    };

    axios
      .post(`${baseUrl}Authentication/SendOTP`, resendOtpPayload)
      .then((response) => {
        

        setNinModalOpen(true);
        setOtpLoader(false);
      })
      .catch((err) => {
        setOtpLoader(false);
        toast.errorToast("something went wrong");
      });
  };

  const updateDetails = (values: any) => {
    setUpdating(true);
    let updateDetailsPayload = {
      ...values,
      religion: +values.religion,
      bvn: userDetails.bvn,
      socialMediaId: +values.socialMediaId,
      idCardNumber: idCardNumber,
    };
    
    updateDetailsPayload.occupation = 0;
    
    if (
      accountType?.toLowerCase() === "current" ||
      accountType?.toLowerCase() === "domiciliary current"
    ) {
      updateDetailsPayload.religion = `${updateDetailsPayload.religion}`;
      updateDetailsPayload.dateOfBirth = updateDetailsPayload.dob;
      delete updateDetailsPayload.dob;
    }
    // (updateDetailsPayload)
    let urlSuffix = "";

    switch (accountType?.toLowerCase()) {
      case accountTypes.swiftSavings:
        urlSuffix = "SwiftSavings/Details";
        break;
      case accountTypes.regularSavings:
        urlSuffix = "SavingsAccount/details";
        break;
      case accountTypes.minorSavings:
        urlSuffix = "MinorSavings/Details";
        break;
      case accountTypes.jointSavings:
        urlSuffix = "JointSavings/Details";
        break;
      case accountTypes.domiciliarySavings:
        urlSuffix = "DomiciliarySavings/Details";
        break;
      case accountTypes.current:
        urlSuffix = "CurrentAccount/CurrentDetails";
        break;
      case accountTypes.jointCurrent:
        urlSuffix = "JointCurrent/JointCurrentDetails";
        break;
      case accountTypes.domiciliaryCurrent:
        urlSuffix = "DomiciliaryCurrent/DomiciliaryCurrentDetails";
        break;

      default:
      // 
    }

    // return

    if (accountType.toLowerCase() != accountTypes.minorSavings) {
      delete updateDetailsPayload.minorDob;
      delete updateDetailsPayload.minorFirstName;
      delete updateDetailsPayload.minorLastName;
      delete updateDetailsPayload.minorMiddleName;
    }

    if (accountType.toLowerCase() == accountTypes.minorSavings.toLowerCase()) {
      setLocalStorageItem(
        "minorFirstName",
        JSON.stringify({ minorFirstName: values.minorFirstName })
      );
    }

    
    // return

    axios
      .post(`${baseUrl}${urlSuffix}`, updateDetailsPayload)
      .then((response) => {
        
        setLocalStorageItem("uploadId", `${response?.data?.obj?.id}`);
        setUpdating(false);
        if (!response?.data?.isSuccess) {
          toast.errorToast(response?.data?.message);
          return;
        }
        if (
          accountType.toLowerCase() == accountTypes.minorSavings.toLowerCase()
        ) {
          setLocalStorageItem("minorId", `${response?.data?.obj?.id}`);
        }
        setOtpLoader(true);
        let ninPayload = {
          id: idCardNumber,
          isSubjectConsent: true,

          phoneNumber: userDetails.phoneNumber,
          bvnPhoneNumber: userNin.phoneNumber,
          bvnFirstName: userNin.firstName,
          bvnLastName: userNin.lastName,
          bvnMiddleName: userNin.middleName,
          bvnDateOfBirth: userNin.dob,
          bvnGender: userNin.gender,
          bvn: userDetails.bvn,
        };
        
        axios
          .post(`${baseUrl}Authentication/ValidateNIN`, ninPayload)
          .then((response) => {
            

            if (response.data.success) {
              toast.successToast("NIN Validated Successfully");
              dispatch(setAccountOpeningStep("document-upload"));
            } else if (
              response.data.message ===
              "Bvn phoneNumber does not match with NIN phoneNumber"
            ) {
              setShowNinModal(true);
              setShowModal(true);
            } else if (
              response.data.message ===
              "FirstName does not match for BVN and NIN"
            ) {
              setShowfirstNameModal(true);
              setShowModal(true);
            } else if (
              response.data.message ===
              "MiddleName does not match for BVN and NIN"
            ) {
              setShowmiddleNameModal(true);
              setShowModal(true);
            } else if (
              response.data.message ===
              "LastName does not match for BVN and NIN"
            ) {
              setShowlastNameModal(true);
              setShowModal(true);
            } else if (
              response.data.message === "Gender does not match for BVN and NIN"
            ) {
              setShowGenderNameModal(true);
              setShowModal(true);
            } else if (
              response.data.message ===
              "Date Of Birth does not match for BVN and NIN"
            ) {
              setShowDoBNameModal(true);
              setShowModal(true);
            } else if (response.data.message === "Bvn middleName is empty") {
              setShowBvnMiddleEmptyModal(true);
              setShowModal(true);
            } else if (response.data.message === "NIN middleName is empty") {
              setShowNinMiddleEmptyModal(true);
              setShowModal(true);
            } else {
              toast.errorToast("Please Input a Valid NIN");
            }
            setOtpLoader(false);
          })
          .catch((err) => {
            toast.errorToast("Invalid NIN. Please Input a Valid NIN");
            
            setOtpLoader(false);
          });

        setUpdating(false);
      })
      // dispatch(setAccountOpeningStep('document-upload'))
      // sendOtp();

      .catch((err) => {
        
        setUpdating(false);
        toast.errorToast(
          err?.response?.data?.title
            ? err?.response?.data?.title
            : err?.response?.data?.message
        );
      });
  };

  const getReligions = () => {
    axios
      .get(`${baseUrl}Enum/Religion`)
      .then((response) => {
        setReligions(response.data);
      })
      .catch((err) => {
        
      });
  };

  const getSocialMediaPlatforms = () => {
    axios
      .get(`${baseUrl}Enum/SocialMedia`)
      .then((response) => {
        setSocialMediaPlatforms(response.data);
      })
      .catch((err) => {
        
      });
  };

  const getExistingDetails = () => {
    let urlSuffix = "";

    switch (accountType?.toLowerCase()) {
      case accountTypes.swiftSavings:
        urlSuffix = "SwiftSavings/existingDetails?bvn=";
        break;
      case accountTypes.regularSavings:
        urlSuffix = "SavingsAccount/existingDetails?bvn=";
        break;
      case accountTypes.minorSavings:
        urlSuffix = "MinorSavings/existingDetails?bvn=";
        break;
      case accountTypes.jointSavings:
        urlSuffix = "JointSavings/existingDetails?bvn=";
        break;
      case accountTypes.domiciliarySavings:
        urlSuffix = "DomiciliarySavings/existingDetails?bvn=";
        break;
      case accountTypes.current:
        urlSuffix = "CurrentAccount/CurrentExistingDetails?Bvn=";
        break;
      case accountTypes.jointCurrent:
        urlSuffix = "JointCurrent/JointCurrentExistingDetails?Bvn=";
        break;
      case accountTypes.domiciliaryCurrent:
        urlSuffix = "DomiciliaryCurrent/DomiciliaryCurrentExistingDetails?Bvn=";
        break;

      default:
      // 
    }

    axios
      .get(`${baseUrl}${urlSuffix}${encryptRequest(userDetails.bvn)}`)
      .then((response) => {
        setUserExistingDetails(response?.data);
        let userData = response?.data;
        formik.initialValues.houseNumber = userData?.houseNumber;
        formik.initialValues.streetName = userData?.streetName;
        formik.initialValues.areaState = userData?.areaState;
        formik.initialValues.nearestBustopLandmark =
          userData?.nearestBustopLandmark;
        formik.initialValues.address = userData?.address;
        formik.initialValues.occupation = userData?.occupation;
      })
      .catch((err) => {
        
      });
  };

  useEffect(() => {
    getReligions();
    getCountries();
    getExistingDetails();
    getSocialMediaPlatforms();
  }, []);

  const handleKeyPress = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault(); // Prevent input of non-numeric characters
    }
  };

  const [selectedState, setSelectedState] = useState("");
  const [lgas, setLgas] = useState([]);

  const handleStateChange = (event) => {
    const selected = event.target.value;
    setSelectedState(selected);

    const state = statesInNigeria.find((state) => state.name === selected);
    if (state) {
      setLgas(state.lgas);
    } else {
      setLgas([]);
    }

    formik.handleChange(event);
  };

  return (
    <div className="update-details-form-body">
      {intialPopup && (
        <CoperateAccountPopUp setInitialPopup={setInitialPopup} />
      )}
      {otpLoader && <Loader />}

      <Modal
        openModal={showModal && showNinModal}
        closeModal={() => setShowModal(false)}
        header="Mobile number MissMatch"
      />
      <Modal
        openModal={showModal && showfirstNameModal}
        closeModal={() => setShowModal(false)}
        header="First name does not match"
        newmessage="The first name on your BVN and NIN does not match. Kindly visit any branch of your BVN enrollment bank or the NIMC office to rectify your NIN details."
        paragraph="Hello Partner, the first name on your BVN does not match the one on your NIN. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the first name mismatch on your BVN/NIN has been resolved. "
      />
      <Modal
        openModal={showModal && showmiddleNameModal}
        closeModal={() => setShowModal(false)}
        header="Middle name mismatch"
        newmessage="Hello Partner, please note that the middle name on your BVN does not match the one on your NIN. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the middle name mismatch on your BVN/NIN has been resolved."
        paragraph="The Middle name on your BVN and NIN does not match. Kindly visit any branch of your BVN enrollment bank or the NIMC office to rectify your NIN details."
      />
      <Modal
        openModal={showModal && showlastNameModal}
        closeModal={() => setShowModal(false)}
        header="Last name does not match"
        newmessage="The Last name on your BVN and NIN does not match. Kindly visit any branch of your BVN enrollment bank or the NIMC office to rectify your NIN details."
        paragraph="Hi Partner, the Last name on your BVN and NIN does not match. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the last name mismatch on your BVN/NIN has been resolved."
      />
      <Modal
        openModal={showModal && showDobNameModal}
        closeModal={() => setShowModal(false)}
        header="Date of Birth does not match"
        newmessage="Please note that the date of birth in your BVN and NIN records does not match. Please visit any branch of your BVN enrollment bank or the NIMC office to update your NIN details."
        paragraph="Hello Partner, the date of birth in your BVN and NIN records does not match. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the Date of birth mismatch on your BVN/NIN has been resolved. "
      />
      <Modal
        openModal={showModal && showGenderNameModal}
        closeModal={() => setShowModal(false)}
        header="Gender Mismatch/mismatch in gender information "
        newmessage="Hi Partner, the gender details on your BVN and NIN do not match. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the Gender mismatch on your BVN/NIN has been resolved.  "
        paragraph="Hi Partner, the gender details on your BVN and NIN do not match. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the Gender mismatch on your BVN/NIN has been resolved.  "
      />

      <Modal
        openModal={showModal && showBvnMiddleEmptyModal}
        closeModal={() => setShowModal(false)}
        header="Middle name is Empty"
        newmessage="The Middle name on your BVN is empty. Kindly visit any branch of your BVN enrollment bank  to rectify your BVN details "
        paragraph="The Middle name on your BVN is empty. Kindly visit any branch of your BVN enrollment bank  to rectify your BVN details "
      />

      <Modal
        openModal={showModal && showNinMiddleEmptyModal}
        closeModal={() => setShowModal(false)}
        header="Middle name is empty"
        newmessage="The Middle name on your NIN is empty. Kindly visit  the NIMC office to rectify your NIN details."
        paragraph="The Middle name on your NIN is empty. Kindly visit  the NIMC office to rectify your NIN details."
      />

      <form onSubmit={formik.handleSubmit}>
        <div className=" card-form pl- pr- ">
          <div className="card-body">
            <h4 className="card-title text-center pl-3 mt-4">Update details</h4>
            <p className="text-center pl-5 no-wrap">
              Hello{" "}
              <span className="font-weight-bold">
                <b>{userDetails.firstName},</b>{" "}
              </span>
              Welcome to The Alternative Bank
            </p>
            <div className="bvn_val mb-4" id="fader">
              <img src={Icon_L} alt="" style={{ marginRight: "20px" }} />
              <small className="sterling-grey-text ml-4 font-weight-bold">
                <b>Update your address if it has changed</b>
              </small>
            </div>
            <div className="form-group">
              <label htmlFor="accountname" className="label_text">
                Account name
              </label>
              <input
                value={`${userDetails.firstName} ${userDetails.lastName}`}
                className="form-control border-dark"
                type="text"
                id="name"
                placeholder="Tunde Emeka Aminah"
                disabled
              />
            </div>

            {/*  */}
            {accountType?.toLowerCase() ===
              accountTypes.minorSavings.toLowerCase() && (
              <>
                <div className="row">
                  <div className="col sec">
                    <div className="row form-row mb-3">
                      <div className="col-lg-6 mr-2">
                        <label htmlFor="firstname" className="label_text">
                          Minor First name<span className="text-danger">*</span>
                        </label>
                        <input
                          name="minorFirstName"
                          onChange={formik.handleChange}
                          value={formik.values.minorFirstName}
                          type="text"
                          className="details form-control  bg-white border-dark"
                          placeholder="Enter minor's first name"
                        />
                        {formik.touched.minorFirstName &&
                        formik.errors.minorFirstName ? (
                          <small className="text-danger">
                            {formik.errors.minorFirstName}
                          </small>
                        ) : null}
                      </div>
                      <div className="col-lg-6">
                        <label htmlFor="secondname" className="label_text">
                          Minor Second name
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          name="minorMiddleName"
                          onChange={formik.handleChange}
                          value={formik.values.minorMiddleName}
                          type="text"
                          className="form-control bg-white text-muted border-dark"
                          placeholder="Enter minor's second name"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col sec">
                    <div className="row form-row mb-3">
                      <div className="col-lg-6 mr-2">
                        <label htmlFor="lastname" className="label_text">
                          Minor Last name<span className="text-danger">*</span>
                        </label>
                        <input
                          name="minorLastName"
                          onChange={formik.handleChange}
                          value={formik.values.minorLastName}
                          type="text"
                          className="form-control bg-white border-dark"
                          placeholder="Enter minor's last name"
                        />
                        {formik.touched.minorLastName &&
                        formik.errors.minorLastName ? (
                          <small className="text-danger">
                            {formik.errors.minorLastName}
                          </small>
                        ) : null}
                      </div>
                      <div className="col-lg-6">
                        <label htmlFor="dateofbirth" className="label_text">
                          Date of Birth (Minor)
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          name="minorDob"
                          max={todaysDate}
                          onChange={formik.handleChange}
                          value={formik.values.minorDob}
                          type="date"
                          className="form-control bg-white border-dark"
                          placeholder="12-04-1989"
                        />
                        {formik.touched.minorDob && formik.errors.minorDob ? (
                          <small className="text-danger">
                            {formik.errors.minorDob}
                          </small>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/*  */}

            <label
              htmlFor="residentialaddress"
              className="label_text my-2 font-weight-bold mt-4"
            >
              <b>Residential address</b>
            </label>

            <div className="row">
              <div className="col sec">
                <div className="row mb-3">
                  <div className="col-md-6 mr-2">
                    <label htmlFor="housenumber" className="label_text">
                      House number <span className="text-danger">*</span>
                    </label>
                    <input
                      name="houseNumber"
                      onKeyPress={handleKeyPress}
                      onChange={formik.handleChange}
                      value={formik.values.houseNumber}
                      onBlur={handleBlurAddressChild}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="No 12"
                    />

                    {formik.touched.houseNumber && formik.errors.houseNumber ? (
                      <small className="text-danger">
                        {formik.errors.houseNumber}
                      </small>
                    ) : null}
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="streetname" className="label_text">
                      Street name<span className="text-danger">*</span>
                    </label>
                    <input
                      name="streetName"
                      onChange={formik.handleChange}
                      value={formik.values.streetName}
                      onBlur={handleBlurAddressChild}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="Bode Thomas"
                    />
                    {formik.touched.streetName && formik.errors.streetName ? (
                      <small className="text-danger">
                        {formik.errors.streetName}
                      </small>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col sec">
                <div className="row mb-3">
                  <div className="col-md-6 mr-2">
                    <label htmlFor="housenumber" className="label_text">
                      Area/State<span className="text-danger">*</span>
                    </label>
                    <select
                      name="areaState"
                      // onChange={formik.handleChange}
                      onChange={handleStateChange}
                      value={formik.values.areaState}
                      onBlur={handleBlurAddressChild}
                      className="form-control border-dark"
                      style={{
                        padding: "13px",
                      }}
                    >
                      <option value="">Select state</option>
                      {statesInNigeria.map((state: any) => {
                        return (
                          <option key={state.name} value={state.name}>
                            {state.name}
                          </option>
                        );
                      })}
                    </select>
                    {formik.touched.areaState && formik.errors.areaState ? (
                      <small className="text-danger">
                        {formik.errors.areaState}
                      </small>
                    ) : null}
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="streetname" className="label_text">
                      Nearest bus-top/landmark
                    </label>
                    <input
                      name="nearestBustopLandmark"
                      onChange={formik.handleChange}
                      value={formik.values.nearestBustopLandmark}
                      onBlur={handleBlurAddressChild}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="Masha round about"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col sec">
                <div className="row form-row mb-3">
                  <div className="col-lg-6 mr-2">
                    <label htmlFor="housenumber" className="label_text">
                      Local Government Area (L.G.A)
                      <span className="text-danger">*</span>
                    </label>
                    <select
                      name="localGovernment"
                      // onChange={formik.handleChange}
                      // value={formik.values.areaState}
                      onChange={formik.handleChange}
                      value={formik.values.localGovernment}
                      onBlur={handleBlurAddressChild}
                      className="form-control border-dark"
                      style={{
                        padding: "13px",
                      }}
                    >
                      {/* <option value="">Select state</option>
                      {statesInNigeria.map((state: any) => {
                        return (
                          <option key={state.name} value={state.name}>
                            {state.name}
                          </option>
                        );
                      })} */}
                      <option value="">Select LGA</option>
                      {lgas.map((lga) => (
                        <option key={lga} value={lga}>
                          {lga}
                        </option>
                      ))}
                    </select>
                    {formik.touched.areaState && formik.errors.areaState ? (
                      <small className="text-danger">
                        {formik.errors.areaState}
                      </small>
                    ) : null}
                    {/* <label htmlFor="housenumber" className="label_text">Area/State<span className="text-danger">*</span></label>
                                    <input name="areaState" onChange={formik.handleChange} value={formik.values.areaState} onBlur={handleBlurAddressChild} type="text" className="form-control bg-white border-dark" placeholder="Lagos"  />
                                    {formik.touched.areaState && formik.errors.areaState ? <small className="text-danger">{formik.errors.areaState}</small> : null} */}
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="streetname" className="label_text">
                      Town
                    </label>
                    <input
                      name="town"
                      onChange={formik.handleChange}
                      value={formik.values.town}
                      onBlur={handleBlurAddressChild}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="Enter your town"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3 mb-4">
              <div className="col form-group">
                <label htmlFor="nationality" className="label_text">
                  Nationality<span className="text-danger">*</span>
                </label>
                <select
                  name="nationality"
                  onChange={formik.handleChange}
                  value={formik.values.nationality}
                  className="form-control border-dark"
                >
                  <option value="">Select nationality</option>
                  {countries.map((country: ICountry) => {
                    return (
                      <option key={country.id} value={country.countrY_CODE}>
                        {country.lonG_DESC_ENG}
                      </option>
                    );
                  })}
                </select>
                {formik.touched.nationality && formik.errors.nationality ? (
                  <small className="text-danger">
                    {formik.errors.nationality}
                  </small>
                ) : null}
              </div>
            </div>

            <div className="form-group mt-3">
              <label htmlFor="address" className="label_text">
                Address<span className="text-danger">*</span>
              </label>
              <input
                name="address"
                onChange={formik.handleChange}
                value={formik.values.address}
                onBlur={formik.handleBlur}
                className="form-control sec border-dark"
                type="text"
                id="address"
                placeholder="No 12 Bode Thomas Masha round about Lagos"
              />
              {formik.touched.address && formik.errors.address ? (
                <small className="text-danger">{formik.errors.address}</small>
              ) : null}
            </div>

            <div className="row d-flex mt-3">
              <div className="col-lg-6 form-group">
                <label htmlFor="religion" className="label_text">
                  Religion
                </label>
                <select
                  name="religion"
                  onChange={formik.handleChange}
                  value={formik.values.religion}
                  className="form-control border-dark"
                >
                  <option value="">Select religon</option>
                  {religions.map((religion: IReligion) => {
                    return (
                      <option key={religion.id} value={religion.id}>
                        {religion.religion}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-lg-6 form-group">
                <label htmlFor="gender" className="label_text">
                  Gender<span className="text-danger">*</span>
                </label>
                <select
                  name="gender"
                  onChange={formik.handleChange}
                  value={formik.values.gender}
                  className="form-control border-dark"
                >
                  <option value="">Select a gender</option>
                  {genders.map((gender: any) => {
                    return (
                      <option key={gender.name} value={gender.value}>
                        {gender.name}
                      </option>
                    );
                  })}
                </select>
                {formik.touched.gender && formik.errors.gender ? (
                  <small className="text-danger">{formik.errors.gender}</small>
                ) : null}
              </div>
            </div>

            <div className="row mb-2 mt-4">
              <div className="col sec">
                <div className="row form-row mb-3">
                  <div className="col-lg-6 mr-2">
                    <label htmlFor="socialMediaId" className="label_text">
                      Social media type
                    </label>
                    <select
                      name="socialMediaId"
                      onChange={formik.handleChange}
                      value={formik.values.socialMediaId}
                      className="form-control border-dark"
                      style={{ paddingTop: "12px", paddingBottom: "12px" }}
                    >
                      <option>--Choose one--</option>
                      {socialMediaPlatforms.map((socialMediaPlatform) => {
                        return (
                          <option
                            key={socialMediaPlatform.id}
                            value={socialMediaPlatform.id}
                          >
                            {socialMediaPlatform.name}
                          </option>
                        );
                      })}
                    </select>
                    {formik.touched.socialMediaId &&
                    formik.errors.socialMediaId ? (
                      <small className="text-danger">
                        {formik.errors.socialMediaId}
                      </small>
                    ) : null}
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="socialMediaHandle" className="label_text">
                      Enter social media link/handle
                    </label>
                    <input
                      name="socialMediaHandle"
                      onChange={formik.handleChange}
                      value={formik.values.socialMediaHandle}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="@john_doe"
                    />
                    {formik.touched.socialMediaHandle &&
                    formik.errors.socialMediaHandle ? (
                      <small className="text-danger">
                        {formik.errors.socialMediaHandle}
                      </small>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group">
              {/* <label htmlFor="idcardtype" className="label_text">Select identity card type</label>

            <ul className="nav nav-pills identity-tab mb-3 nav-fill" id="pills-tab" role="tablist">
              {meansOfIdentification.map((identification:IMeansOfIdentification) => {
                  return(
                    <li className="nav-item" key={identification.id} onClick={() => handleSetIdCardType(identification.id)}>
                        <a className={`nav-link text-nowrap pl-0 pt-2 
                            ${storedUserDataIdCard ? identification.id == storedUserDataIdCard ? "active" : ""  :  identification.id == 1 ? "active" : ""}`
                        } 
                            id="pills-int-tab" data-toggle="pill"
                            href="#pills-int" role="tab" aria-controls="pills-int" aria-selected="true">{identification.text}</a>
                    </li>
                  )
              })}
            </ul> */}
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane show fade active"
                  id="pills-int"
                  role="tabpanel"
                  aria-labelledby="pills-int-tab"
                >
                  <div className="row mb-4">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label
                          htmlFor="nextofkin"
                          className="label_text mb-2"
                          data-bs-toggle="modal"
                          data-bs-target="#idCardSampleModal"
                        >
                          National ID Card
                          <i className="bx bxs-info-circle cursor-pointer"></i>
                        </label>
                        {/* <input name="idCardNumber" onChange={formik.handleChange} value={formik.values.idCardNumber} className="form-control border-dark" type="text" id="name"
                        placeholder="Enter ID card number" /> */}
                        <input
                          name="idCardNumber"
                          onChange={(e) => setIdCardNumber(e.target.value)}
                          value={idCardNumber}
                          className="form-control border-dark"
                          type="text"
                          id="name"
                          placeholder="Enter ID card number"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group identity">
                        <label htmlFor="issuedate" className="label_text mb-2">
                          Issue Date
                        </label>
                        {/* <input name="issueDate" max={todaysDate} onChange={formik.handleChange} value={formik.values.issueDate} type="date" className="form-control border-dark bg-white" placeholder="dd/mm/yyyy" /> */}
                        <input
                          name="issueDate"
                          max={todaysDate}
                          onChange={(e) => setIdCardissueDate(e.target.value)}
                          value={idCardIssueDate}
                          type="date"
                          className="form-control border-dark bg-white"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                    </div>

                    {/* {(idCardtype == 2 || idCardtype == 4) &&
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor="expirydate" className="label_text mb-2">Expiry Date</label>
                        <input name="expiryDate" min={todaysDate} onChange={formik.handleChange} value={formik.values.expiryDate} type="date" className="form-control border-dark bg-white" placeholder="dd/mm/yyyy" />
                      </div>
                    </div>
                  } */}
                  </div>
                </div>
              </div>
            </div>
            <OtpDialogModal
              openModal={ninModalOpen}
              closeModal={() => setNinModalOpen(false)}
              routeTo="document-upload"
            />

            <div className="form-group mt-3">
              <label htmlFor="refferalcode" className="label_text">
                DAO/Referral code(optional)
              </label>
              <input
                name="referralCode"
                onChange={formik.handleChange}
                value={formik.values.referralCode}
                onBlur={formik.handleBlur}
                className="form-control border-dark"
                type="text"
                id="name"
                placeholder="Enter referral code"
              />
            </div>

            <div className="d-flex justify-content-end mt-4">
              <button
                onClick={() => {
                  goToStep("ex-bvn-validation");
                }}
                style={{ marginRight: "10px" }}
                className="btn btn-outline-gold mr-3 btn-filled-white"
              >
                Previous
              </button>
              {updating ? (
                <div className="spinner-border text-gold" role="status">
                  <span className="sr-only"></span>
                </div>
              ) : (
                <button type="submit" className="btn btn-filled-red">
                  Proceed
                </button>
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ExUpdateDetailsSavingsDialog;
